import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Header from "../components/site/Header";
import Footer from "../components/site/Footer";

const METHOD = [
  {
    kicker: "01 · Filosofía",
    title: "El maquillaje que no se ve.",
    body:
      "Trabajo desde una convicción: el mejor maquillaje es el que la persona no siente. Se mira al espejo y piensa 'estoy yo, mejor'. No 'está el maquillaje, yo por debajo'. Todo lo que hago sale de ese principio.",
  },
  {
    kicker: "02 · Método",
    title: "Antes que un pincel, una conversación.",
    body:
      "Cada sesión empieza con 15 minutos sin producto sobre la mesa. Necesito entender el evento, la piel, la historia — y sobre todo qué quieres sentir cuando te veas. Ese momento define lo que uso después.",
  },
  {
    kicker: "03 · Piel",
    title: "La base no se aplica. Se construye.",
    body:
      "El 80% del resultado que ves en foto es piel. Por eso trabajo con productos que se ven reales, no cubridores planos: skin-first, humectada, con luz propia. La piel decide si el resto del maquillaje aguanta hasta el final del evento.",
  },
  {
    kicker: "04 · Color",
    title: "Paletas construidas, no elegidas.",
    body:
      "No abro un case y saco lo que hay. Cada paleta se mezcla en el momento — para tu piel, tu vestido, la luz del venue, y la cámara del fotógrafo. Es la razón por la que ningún look que hago se repite.",
  },
  {
    kicker: "05 · Presencia",
    title: "El tiempo también es parte del servicio.",
    body:
      "Nunca maquillo con prisa. Reservo cada evento con el aire necesario — bloqueando el tiempo antes y después para que ni tú ni yo estemos mirando el reloj. Cuando llegas a mi silla, tienes mi atención completa, mi mesa completa, y tantos ajustes como necesites hasta que digas 'esto'.",
  },
];

export default function Method() {
  return (
    <div className="min-h-screen bg-[#FAFAFA]" data-testid="method-page">
      <Helmet>
        <title>El Método — Abril Suarez Makeup Artist</title>
        <meta
          name="description"
          content="La filosofía detrás del trabajo de Abril Suarez: skin-first, paletas construidas, tiempo pleno para cada clienta."
        />
      </Helmet>
      <Header />

      <section className="px-6 sm:px-10 pt-32 pb-16 max-w-4xl mx-auto">
        <p className="overline text-[#8B6D5E] mb-4">— El Método</p>
        <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl leading-[1.02] mb-6">
          Cómo trabajo, <em className="text-[#8B6D5E]">y por qué.</em>
        </h1>
        <p className="text-lg leading-relaxed text-[#3D3D3D] max-w-2xl">
          Este no es un servicio de maquillaje. Es un método construido durante años,
          para clientas que no toleran verse bien — que necesitan verse como ellas mismas,
          multiplicadas por diez.
        </p>
      </section>

      <div className="border-t border-[#E8E1DA]" />

      <section className="px-6 sm:px-10 py-8 max-w-4xl mx-auto">
        {METHOD.map((m, i) => (
          <article
            key={i}
            className="grid md:grid-cols-[140px_1fr] gap-8 md:gap-16 py-16 border-b border-[#E8E1DA] last:border-b-0"
            data-testid={`method-item-${i}`}
          >
            <p className="overline text-[#8B6D5E]">{m.kicker}</p>
            <div>
              <h2 className="font-serif text-3xl sm:text-4xl mb-5 leading-tight">{m.title}</h2>
              <p className="text-lg leading-relaxed text-[#3D3D3D]">{m.body}</p>
            </div>
          </article>
        ))}
      </section>

      <section className="px-6 sm:px-10 py-24 bg-[#F7F0E8]">
        <div className="max-w-3xl mx-auto text-center">
          <p className="overline text-[#8B6D5E] mb-6">Un último principio</p>
          <p className="font-serif text-3xl sm:text-4xl leading-tight text-[#2E2617] mb-8">
            El maquillaje termina cuando <em className="text-[#8B6D5E]">tú te ves y sonríes.</em>
          </p>
          <p className="text-lg leading-relaxed text-[#3D2A1F] max-w-2xl mx-auto">
            Antes de eso, seguimos. No importa si son 5 minutos más, 20, o una hora.
            Porque cuando cierras los ojos esa noche, no vas a recordar la técnica.
            Vas a recordar cómo te sentiste al verte.
          </p>
          <div className="mt-10">
            <Link
              to="/#contacto"
              className="inline-flex items-center gap-2 border border-[#1A1A1A] px-8 py-4 overline hover:bg-[#1A1A1A] hover:text-[#FAFAFA] transition-colors"
              data-testid="method-cta"
            >
              Reservar entrevista inicial →
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
